import Sticky from "sticky-js";

export default () => {
  const isMatchingMediaQuery = (mediaQuery: string): boolean => {
    return window.matchMedia(mediaQuery).matches;
  };

  if (isMatchingMediaQuery("(max-width: 991px)")) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const sticky = new Sticky(".sticky-mobile");
  } else {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const sticky2 = new Sticky(".sticky-desktop");
  }
};
